import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { AuthenticationService } from 'src/app/services/shared/auth.service';
import { AccountInfoComponent } from './account-info/account-info.component';
declare var $: any;
@Component({
  selector: 'app-settings-v2',
  templateUrl: './settings-v2.component.html',
  styleUrls: ['./settings-v2.component.scss']
})
export class SettingsV2Component implements OnInit {
  @ViewChild(AccountInfoComponent) accountInfoComponent: AccountInfoComponent;
  intFeild: any;
  fromadd: boolean = true;
  intId: any;
  intFormInVaild = false;
  can_upload = 0
  currentPlatfrom: any;

  isPOSTab = false;
  POS = []; posTypes = []; posId: any; posLoad: boolean = true;
  isPOSTypeSelected: boolean;
  posParameters: any[]; posFeild: any; posSucess: boolean = false;
  isSubmittedPOS = false; isPOSFormInvalid = false; posFail: boolean = false;

  mainIntLoader = true;
  loggedUserRole: any;

  oderActionDetails = []; isOderActionTab = false;
  orderActionLoader = false; orderActionFilterSelected = false;
  selectedOrderActionFranchise: any = null; selectedOrderActionShop: any = null;

  userId
  user
  isDataLoaded = false;
  isIntShow = false;
  platform_type = 0;
  deliveryPlatforms = [];

  addedPOS = []
  intParameters = <any>[];
  isPlatformTypeSelected = false
  submittedAddInt = false;
  integratedPlatforms = [];
  acceptingOrders: boolean = false;
  loading = false;
  loaderSpin = false; loaderSpinPos = false;
  submitted = false;
  clearField = false;
  isSuccess = false;
  intSucess = false;
  intEditSucess = false;
  integrationShopSelected = false;
  message = '';
  returnUrl: string;
  error: string;
  validate: true;
  franchises: any;
  allow_multiple_select: true;
  shops: any = []

  qtd: any = [];


  constructor(
    private authService: AuthenticationService,
    private spinner: NgxSpinnerService,
  ) { }



  ngOnInit(): void {
    this.spinner.show();

    this.getCurrentUser();

  }

  onGeneralClick() {
  }

  onIntClick() {
    this.accountInfoComponent.restValidation()
  }

  onPOSClick() {
    this.accountInfoComponent.restValidation()
  }

  onOrderActionClick() {
    this.accountInfoComponent.restValidation()
  }

  getCurrentUser() {

    this.loggedUserRole = this.authService.getLoggedUser().user_roles.role_id;
  }

}